import { Injectable, signal } from '@angular/core';
import { NavTab } from '../navigation-tabs.interfaces';

@Injectable()
export class NavTabsStoreService {
  private readonly tabsSignal = signal<NavTab[]>([]);

  readonly tabs = this.tabsSignal.asReadonly();

  setTabs(tabs: NavTab[]): void {
    this.tabsSignal.set(tabs);
  }
}
